import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';

const EmptyState = ({ message, illustration, buttonText, onButtonClick }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                textAlign: 'center',
                padding: 4,
            }}
        >
            {illustration && (
                <Box
                    component="img"
                    src={illustration}
                    alt="Empty state illustration"
                    sx={{ width: '100%', maxWidth: 300, mb: 2 }}
                />
            )}
            <Typography variant="h6" component="p" sx={{ mb: 2 }}>
                {message}
            </Typography>
            {buttonText && onButtonClick && (
                <Button variant="contained" onClick={onButtonClick}>
                    {buttonText}
                </Button>
            )}
        </Box>
    );
};

EmptyState.propTypes = {
    message: PropTypes.string.isRequired,
    illustration: PropTypes.string,
    buttonText: PropTypes.string,
    onButtonClick: PropTypes.func,
};

export default EmptyState;